import React from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import InputField from '../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import apiClient from '../../../../Services/ApiClient';
import useApiClient from '../../../Base/Hooks/useApiClient';

interface Props {
	patientId: string;
	defaultValues: object;
	onSuccess: () => void;
}

const validationSchema = yup.object({
	fullName: yup.string().required(),
	relationship: yup.string().required(),
});

const PatientProfilePersonActingOnBehalfOfAPatient: React.FC<Props> = ({
	patientId,
	defaultValues,
	onSuccess,
}) => {
	const { displayError } = useApiClient();
	const formMethods = useForm({
		defaultValues: defaultValues || {},
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = async (values: any) => {
		try {
			await apiClient.post('/user/' + patientId + '/meta/', {
				key: 'personActingOnBehalfOfAPatient',
				value: {
					fullName: values?.fullName,
					relationship: values?.relationship,
				},
			});
			onSuccess();
		} catch (e) {
			displayError(e);
		}
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<InputField
				name='fullName'
				label='component.patientProfilePersonActingOnBehalfOfAPatient.form.fullName'
				className='mb-3'
				isRequired
			/>
			<InputField
				name='relationship'
				label='component.patientProfilePersonActingOnBehalfOfAPatient.form.relationship'
				className='mb-4'
				isRequired
			/>
			<SubmitButton onSubmit={handleSubmit} title='base.shared.save' />
		</FormWrapper>
	);
};

export default PatientProfilePersonActingOnBehalfOfAPatient;
